import { type ComponentProps } from 'react'
import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-8 w-full rounded-md border border-input bg-surface-raised px-2.5 py-1 text-xs text-content shadow-none transition-colors outline-none',
        'placeholder:text-content-muted',
        'focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent/25',
        'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:opacity-60',
        'aria-invalid:border-status-error aria-invalid:ring-status-error/20',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
